// export const EMAIL_ALREADY_IN_USE = 'Этот E-mail вже зареєстрований'
export const WRONG_PASSWORD = 'Указан неверный E-mail или пароль'
export const WEAK_PASSWORD = 'Длинна пароля должна быть не менее 6 символов'
export const USER_NOT_FOUND = 'Этот E-mail не зарегистрирован'
export const ALREADY_IN_USE = 'Этот E-mail уже зарегистрирован'
export const USER_NOT_A_MEMBER = 'Нет доступа к этому аккаунту'
export const USER_IS_BLOCKED = 'Вас заблокировали в этом аккаунте'
export const OPERATION_NOT_ALLOWED = 'Данный способ входа в аккаунт не доступен'
